import SentResetPassword from "./sentResetPassword.container";

export default SentResetPassword;
